import { render, staticRenderFns } from "./billingSecs.vue?vue&type=template&id=2838b27a"
import script from "./billingSecs.vue?vue&type=script&lang=js"
export * from "./billingSecs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports